import { objectDepth, objectFilter, objectIs, objectMap } from 'object-fn-ts/lib';
import { CommonProofCZ, CommonProofLZ } from 'types';
import { CommonProofLZTable } from 'types/proof';

type ProofBuilder = (proofObject: any, selectedProof: string | number | symbol) => any

export const buildEC: ProofBuilder = (proofObject, selectedProof) => {
  const data: any[] = (proofObject[selectedProof] as any).table;
  if (data.every(e => objectIs(e) && objectDepth(e) === 1 && Object.keys(e).length === 1)) {
    const objectData = data.reduce((acm: any, e: any) => {
      return {
        ...acm,
        [Object.keys(e)[0]]: Object.values(e)[0]
      };
    }, {});
    return objectData;
  } else {
    return data;
  }
};

export const buildEL: ProofBuilder = (proofObject, selectedProof) => {
  return objectFromDeepEntries(
    objectDeepEntries(proofObject[selectedProof])
      .map(([ key, val ]) => [
        key.replace(/ \d+$/, ''),
        typeof val === 'object'
          ? Array.isArray(val)
            ? val.map(([ key2, val2 ]) => [ key2.replace(/ \d+$/, ''), val2 ])
            : val
          : val
      ])
  );
};

export const buildZC: ProofBuilder = (proofObject, selectedProof) => {
  const raw = proofObject[selectedProof] as CommonProofCZ;
  const allowHeaderless =
    typeof selectedProof === 'string' &&
    selectedProof.toLowerCase().includes('ultrassonografia de carcaca');
  const filteredTable = {
    ...raw,
    table: raw.table.filter((e) => allowHeaderless || e.headers.length > 0),
  };
  const treatedKeys = objectFromDeepEntries(objectDeepEntries(filteredTable)
    .map(([ key, val ]: [string, any]) => [
      key.replace(/ \d+$/g, ''),
      Array.isArray(val) && val.every(c => Array.isArray(c) && c.length === 2)
        ? val.map(([ key2, val2 ]) => [ key2.replace(/ \d+$/g, ''), val2 ])
        : val
    ])) as CommonProofCZ;
  const tableKeys = treatedKeys.table.map(e => e.name.toLowerCase());
  const duplicatedRm = objectFilter(
    treatedKeys,
    (key) => !tableKeys.includes(`${key}`.toLowerCase())
  ) as CommonProofCZ;
  return duplicatedRm;
};

export const buildZL: ProofBuilder = (proofObject, selectedProof) => {
  const data: CommonProofLZTable = proofObject[selectedProof];
  const filteredData = data.table.filter(
    (e: any) => typeof e === 'object' &&
      'headers' in e &&
      !([ 'Touro', 'Raça', 'Código' ].includes(e.headers))
  );
  return filteredData;
};

const objectDeepEntriesRec = (o: object, count = 0): any[] => {
  const entries = Object.entries(o);
  return entries.map(
    ([ key, value ]) =>
      ([ key, (objectIs(value) ? [ ...objectDeepEntriesRec(value, count + 1) ] : value) ])
  );
};

const objectDeepEntries = (o: object) => objectDeepEntriesRec(o);

const isArray = (val: any) => val instanceof Array;

const objectFromDeepEntriesRec = (arr: any, count = 0): any => {

  const entries = Object.fromEntries(arr);
  return objectMap(entries, (_, value) => {
    if (isArray(value) && value.every((el: any) => isArray(el))) {
      return objectFromDeepEntriesRec(value, count + 1);
    }
    return value;
  });
};

const objectFromDeepEntries = (arr: any[]): unknown => objectFromDeepEntriesRec(arr);
